var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLogo1 = function SvgIconLogo1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "M21.567 0A24.9 24.9 0 0 0 11.27 3.693l6.157 1.519zM14.383 9.06l3.043-3.848-6.156-1.501z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "M14.383 9.06 11.27 3.71 10 9.924zM11.27 3.71a24.9 24.9 0 0 0-7.53 7.455l6.261-1.26z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "m9.132 14.253.87-4.331-6.262 1.26zM17.428 5.21l4.139 1.036V0zM0 21.397h6.278l-1.026-4.452z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "M9.132 14.251 3.74 11.18l1.513 6.108zM3.74 11.18A24.25 24.25 0 0 0 0 21.396l5.253-4.107zM17.426 5.21l-3.043 3.831a18.5 18.5 0 0 1 7.182-2.812zM14.383 9.055l-4.365.862-.887 4.331a18.7 18.7 0 0 1 5.252-5.193"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "m9.13 14.25-3.86 3.02 1.026 4.106A17.9 17.9 0 0 1 9.13 14.25M0 27.11a24.46 24.46 0 0 0 3.722 10.215l1.53-6.109zM9.114 34.238l-3.86-3.02-1.531 6.109zM3.74 37.328c1.93 3.002 4.505 5.539 7.513 7.471l-1.27-6.211zM14.365 39.443 10 38.563l1.252 6.228zM5.252 31.216l1.026-4.107H0zM21.567 48.51v-6.229l-4.487 1.001z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "m14.365 39.445-3.113 5.35 6.156-1.52zM11.252 44.798a24.9 24.9 0 0 0 10.314 3.71l-4.14-5.211zM5.252 31.216l3.86 3.02a18.2 18.2 0 0 1-2.834-7.127zM9.113 34.234l.87 4.331 4.365.88a19 19 0 0 1-5.235-5.21M14.367 39.445l3.044 3.83 4.156-1a19 19 0 0 1-7.2-2.83M27.326 48.516a24.9 24.9 0 0 0 10.297-3.693l-6.157-1.518zM34.508 39.453l-3.043 3.83 6.139 1.519zM34.51 39.449l3.095 5.349 1.27-6.212zM37.606 44.798a24.9 24.9 0 0 0 7.53-7.454l-6.261 1.26z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "m39.762 34.258-.887 4.33 6.26-1.242v-.017zM31.465 43.274l-4.139-1v6.228zM48.876 27.11h-6.278l1.026 4.451z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "m39.762 34.256 5.374 3.07-1.513-6.107z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "M45.136 37.327a24.5 24.5 0 0 0 3.74-10.233L43.623 31.2zM31.465 43.284l3.044-3.83a18.5 18.5 0 0 1-7.183 2.812zM34.51 39.467l4.365-.863.887-4.33a19.5 19.5 0 0 1-5.252 5.193M39.762 34.251l3.86-3.02-1.026-4.106a18.4 18.4 0 0 1-2.834 7.126M48.876 21.396a24.46 24.46 0 0 0-3.722-10.216l-1.531 6.109zM39.762 14.268l3.86 3.02 1.531-6.108z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "m39.762 14.268 5.391-3.088-6.278-1.242z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "M45.154 11.182c-1.93-3.002-4.505-5.539-7.513-7.471l1.27 6.212zM34.51 9.06l4.365.88-1.252-6.23zM43.624 17.29l-1.026 4.106h6.278zM27.326 0v6.246l4.487-1.018z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "m34.508 9.06 3.113-5.35-6.156 1.52z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "M37.623 3.71A24.9 24.9 0 0 0 27.309 0l4.14 5.212zM43.623 17.293l-3.861-3.02a18.2 18.2 0 0 1 2.834 7.127zM39.762 14.266l-.87-4.331-4.365-.88c2.07 1.38 3.861 3.14 5.235 5.21M34.509 9.057l-3.044-3.83-4.139 1.018a18.5 18.5 0 0 1 7.183 2.812M24.438 9.398l-4.383 7.524h8.783zM28.838 16.922l-4.4 7.541h8.766zM33.206 24.46l-4.366 7.542h8.766zM20.055 32.002l4.383-7.541h-8.766z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "m28.838 32.002 4.366-7.541h-8.766z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "m24.438 24.463 4.4-7.541h-8.783zM15.672 24.46l-4.383 7.542h8.766zM24.438 9.398l-4.383 7.524h8.783zM28.838 16.922l-4.4 7.541h8.766zM33.206 24.46l-4.366 7.542h8.766z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "m20.055 32.002 4.383-7.541h-8.766zM28.838 32.002l4.366-7.541h-8.766z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1E0",
    d: "m24.438 24.463 4.4-7.541h-8.783zM15.672 24.46l-4.383 7.542h8.766zM9.114 34.234l.887 4.331-6.26-1.242z"
  })));
};
export default SvgIconLogo1;